import styled from "styled-components"
import { media } from "utils/utils"

export const Body = styled.div`
  padding-top: ${props => (props.hasMessage ? "120px" : "90px")};
  position: relative;
  ${media.md`
     padding-top: ${props => (props.hasMessage ? "110px" : "80px")};
  `};
  background-color: #ffffff;
  padding-bottom: 50px;
`

export const Header = styled.header`
  display: flex;
  align-items: center;
  background-color: ${props => props.theme.colors.headerBGcolour};
  height: 140px;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 99;

  @media (max-width: 800px) {
    height: 60px;
  }
`

export const Footer = styled.footer``
